<template>
  <v-card style="border-radius: 12px;" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'" elevation="10">
    <v-card-title class="heading">
      <v-row align="center" class="ma-0">
        <span style="color: #47464A; font-weight: 600;">Line</span>
        <v-spacer></v-spacer>
        <v-btn icon depressed @click="onEditClick" :disabled="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.33325 16.6666H6.66658L15.4166 7.91663C15.8586 7.47461 16.1069 6.87509 16.1069 6.24997C16.1069 5.62485 15.8586 5.02533 15.4166 4.5833C14.9746 4.14127 14.375 3.89294 13.7499 3.89294C13.1248 3.89294 12.5253 4.14127 12.0833 4.5833L3.33325 13.3333V16.6666Z"
              stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.25 5.41669L14.5833 8.75002" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onDeleteClick" :loading="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33325 5.83331H16.6666" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.33325 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.6667 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M4.16675 5.83331L5.00008 15.8333C5.00008 16.2753 5.17568 16.6993 5.48824 17.0118C5.8008 17.3244 6.22472 17.5 6.66675 17.5H13.3334C13.7754 17.5 14.1994 17.3244 14.5119 17.0118C14.8245 16.6993 15.0001 16.2753 15.0001 15.8333L15.8334 5.83331"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed color="#47464A" @click="onCloseClick" :disabled="isDeleting">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Distance:</div>
          <div style="margin-top: 10px; color: #47464A;">{{ Layer | distanceDisplay }} meters</div>
        </div>
        <v-divider></v-divider>
      </div>
      <div v-if="Feature['str_description']" style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Description:</div>
          <div style="margin-top: 10px; color: #47464A;">{{ Feature['str_description'] }}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { DIALOG_TYPES, DialogOptions } from "../../../../helpers/dialogs"
import { getPolylineDistance } from "../../../../helpers/spatial"
import { FEATURE_GROUPS } from "../../../../helpers/leaflet/constants"

const _PolylineMap = Symbol.for("_PolylineMap")
const _PolylineLayer = Symbol.for("_PolylineLayer")
const _PolylineFeature = Symbol.for("_PolylineFeature")

export default {
  name: "PolylineViewCard",
  inject: { _PolylineFeature, _PolylineLayer, _PolylineMap },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isDeleting: false,
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onDeleteClick() {
      this.$dialog(new DialogOptions({
        title: "Delete Line",
        content: "Are you sure you want to delete this line?",
        type: DIALOG_TYPES.CONFIRM,
        onConfirm: this.deleteHandler
      }))
    },
    deleteHandler() {
      const f = () => {
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].removeLayer(this.Layer)
        FloatingCardsEventBus.$emit("close")
      }

      this.isDeleting = true
      this.Feature.delete(this.Feature["id_processing_geometry"], f)
        .finally(() => {
          this.isDeleting = false
        })
    },
    onEditClick() {
      this.$emit("update:mode", FEATURE_CARD_STATE.EDIT)
    },
  },
  filters: {
    distanceDisplay(value, transformation = 1) {
      return getPolylineDistance(value) * transformation
    }
  },
  computed: {
    Map() {
      return this._PolylineMap()
    },
    Feature() {
      return this._PolylineFeature()
    },
    Layer() {
      return this._PolylineLayer()
    },
  },
}
</script>

<style scoped></style>
